export default ({
  namespaced: true,
  state: {
    view: 'loader',
    // type: 'index',
    dialog: false
  },
  getters: {
    dialog: state => {
      return state.dialog
    }
  },
  mutations: {
    change_dialog (state, payload) {
      state.dialog = payload
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/loader.js